import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import FileSaver, { saveAs } from 'file-saver';
import * as JSZip from 'jszip';
import { DateFormatPipe } from 'src/app/pipe/date-format.pipe';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlLogIndexdbService } from 'src/app/service/xml-log-indexdb.service';
import xmlFormat from 'xml-formatter';

@Component({
  selector: 'app-xml-logs-screen',
  templateUrl: './xml-logs-screen.component.html',
  styleUrls: ['./xml-logs-screen.component.scss']
})
export class XmlLogsScreenComponent implements OnInit {
  searchResults: any[] = [];
  displayResults: any[] = [];
  performanceResults: any[] = [];
  hideXMLClicks: boolean = false;
  onRefreshClick: boolean = false;

  constructor(private xmlLogIndexdbService: XmlLogIndexdbService, private _route: Router, private sandboxPageStateService: SandboxPageStateService, private datePipe: DateFormatPipe) {}

  /* pagination start */
  public pSettings = {
    start: 0,
    startLabel: 1,
    length: 21,
    totalButton: 0
  };
  public paginationButtonList: any = [];
  public displayXmlLogList: any = [];
  public activePaginationBeforeButton: number = 1;
  public activePaginationAfterButton: number = 1;

  ngOnInit(): void {
    this.getLogs();
  }

  check: boolean = false;

  //pagination start
  loadData(param: any) {}

  getFilter() {
    this.paginationButtonList = [];
    this.displayXmlLogList = [];
    let xmlLogList = this.searchResults;
    let xmlLogListCount = xmlLogList.length;

    //to enable/disable  refresh icon in xml log
    if (xmlLogListCount > 0 || this.onRefreshClick) {
      this.hideXMLClicks = true;
    }
    this.onRefreshClick = true;
    //end

    let activePaginationButton = this.pSettings.start;
    let activePaginationButtonLabel = this.pSettings.startLabel;
    let perPageXmlLog = this.pSettings.length;
    let totalPaginationButton = xmlLogListCount / perPageXmlLog;
    if (totalPaginationButton % 1 != 0) {
      totalPaginationButton = Math.ceil(totalPaginationButton);
    }
    this.pSettings.totalButton = totalPaginationButton;

    let paginationEndNumber: any = 0;
    let paginationStartNumber: any = 0;
    if (totalPaginationButton < 4) {
      paginationStartNumber = 0;
      paginationEndNumber = 3;
      if (paginationEndNumber > totalPaginationButton) {
        paginationEndNumber = totalPaginationButton;
      }
    } else {
      if (activePaginationButton === 0) {
        paginationStartNumber = 0;
        paginationEndNumber = 3;
      } else {
        paginationStartNumber = activePaginationButton - this.activePaginationBeforeButton;
        paginationEndNumber = activePaginationButton + this.activePaginationAfterButton + 1;
      }
      if (paginationEndNumber > totalPaginationButton) {
        paginationEndNumber = totalPaginationButton;
        paginationStartNumber = paginationEndNumber - (this.activePaginationAfterButton + this.activePaginationBeforeButton + 1);
      }
    }
    for (let i = paginationStartNumber; i < paginationEndNumber; i++) {
      var row: any = {};
      row.start = i;
      row.label = i + 1;
      this.paginationButtonList.push(row);
    }

    let startFrom = activePaginationButton * perPageXmlLog;
    let endTo = startFrom + perPageXmlLog;
    for (let i = startFrom; i < endTo; i++) {
      if (typeof xmlLogList[i] != 'undefined') {
        this.displayXmlLogList.push(xmlLogList[i]);
      }
    }
  }

  updateStart(i: any) {
    this.pSettings.start = i;
    this.pSettings.startLabel = i + 1;
    this.getFilter();
  }

  triggerPagination(type: 'back' | 'next') {
    let startIndex = this.pSettings.start;
    let totalButton = this.pSettings.totalButton;
    if (type === 'back') {
      if (startIndex != 0) {
        startIndex = startIndex - 1;
      }
    } else {
      if (startIndex != totalButton - 1) {
        startIndex = startIndex + 1;
      }
    }
    this.pSettings.start = startIndex;
    this.pSettings.startLabel = startIndex + 1;
    this.getFilter();
  }
  //pagination end

  removeLog(key: string) {
    const currentIndex = this.searchResults.findIndex((obj) => obj.key === key);

    if (currentIndex !== -1) {
      this.xmlLogIndexdbService.removeXmlLogFromIndexDbByKey(key, this.sandboxPageStateService.getIndexDBConfig());
      // this.sandboxPageStateService.getXMLLogsMap().delete(key);
      this.searchResults.splice(currentIndex, 1);
      this.getFilter();
    }
  }

  viewLogOld(key: string) {
    const url = this._route.createUrlTree(['/viewLog/' + key]);
    window.open(url.toString() + '?log=true', '_blank');
  }

  async viewLog(key: string) {
    await this.xmlLogIndexdbService.getXmlLogByLabel(key, this.sandboxPageStateService.getIndexDBConfig()).then((selectedLogDetail: any) => {
      var file;
      let resultCount = selectedLogDetail.length;
      if (resultCount > 0) {
        let xml = selectedLogDetail[0].xml;
        try {
          file = new Blob([xmlFormat(xml || '')], { type: 'application/xml' });
        } catch (error: any) {
          file = new Blob([xml || ''], { type: 'application/json' });
        }
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        var anchorElement = document.createElement('a');
        anchorElement.href = fileURL;
        anchorElement.target = '_blank';
        document.body.appendChild(anchorElement);
      }
    });
  }

  deleteLocal() {
    this.searchResults = [];
    this.displayXmlLogList = [];
    this.displayResults = [];
    this.performanceResults = [];
    this.sandboxPageStateService.resetRequest();
    this.sandboxPageStateService.resetResponse();
    this.sandboxPageStateService.resetXMLLogsMap();
    this.sandboxPageStateService.resetPerformanceLogs();
    this.sandboxPageStateService.deleteAllLogFromIndexDB();
  }

  closePannel() {
    let patchSandboxSourceData = { hideSideMenu: 'Yes' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  async getLogs() {
    this.searchResults = [];
    this.performanceResults = [];
    /* this.sandboxPageStateService.getXMLLogsMap().forEach((value: any, key: string) => {
      const responseObject = {
        key: key,
        value: value || ''
      };
      this.searchResults.push(responseObject);
    });*/
    this.searchResults = await this.sandboxPageStateService.getXmlLogFromIndexDB();
    this.performanceResults = await this.sandboxPageStateService.getPerfomanceLogFromIndexDB();
    // store to local
    /* this.sandboxPageStateService.getPerformanceLogs().forEach((performanceLog) => {
      const responseObject = {
        key: performanceLog.key,
        value: performanceLog.responseTime || ''
      };
      this.performanceResults.push(responseObject);
    });*/

    this.getFilter();
  }

  async downloadAllXMLs() {
    let xmlLogLists = await this.sandboxPageStateService.getXmlLogFromIndexDB();
    var zip = new JSZip();
    xmlLogLists.forEach((xmlLogList: any) => {
      try {
        zip.file(xmlLogList.key + '.xml', new Blob([xmlFormat(xmlLogList.value, { collapseContent: true })], { type: 'application/xml' }));
      } catch (error: any) {
        zip.file(xmlLogList.key + '.json', new Blob([xmlLogList.value], { type: 'application/json' }));
      }
    });
    let currentDate: string = new Date().toString();
    let formattedDate = this.datePipe.transform(currentDate, 'medium');
    zip.generateAsync({ type: 'blob' }).then((blob: string | Blob) => saveAs(blob, `XML-logs ${formattedDate}.zip`));
  }

  async downloadXML(key: string) {
    await this.xmlLogIndexdbService.getXmlLogByLabel(key, this.sandboxPageStateService.getIndexDBConfig()).then((selectedLogDetail: any) => {
      let resultCount = selectedLogDetail.length;
      if (resultCount > 0) {
        let xml = selectedLogDetail[0].xml;
        try {
          let currentDate: string = new Date().toString();
          let formattedDate = this.datePipe.transform(currentDate, 'medium');
          var blob = new Blob([xmlFormat(xml, { collapseContent: true })], { type: 'application/xml' });
          FileSaver.saveAs(blob, key.replace('.', '') + ` ${formattedDate}.xml`);
        } catch (error: any) {
          var blob = new Blob([xml], { type: 'application/json' });
          FileSaver.saveAs(blob, key.replace('.', '') + '.json');
        }
      }
    });
  }
}
